var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoading = function SvgLoading(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26 26",
    width: 26,
    height: 26,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L26,0 L26,26 L0,26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    clipRule: "nonzero",
    d: " M24,0 C24,0 24,24 24,24 C24,24 0,24 0,24 C0,24 0,0 0,0 C0,0 24,0 24,0",
    fillOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_4)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillOpacity: 0,
    d: " M24,0 C24,0 24,24 24,24 C24,24 0,24 0,24 C0,24 0,0 0,0 C0,0 24,0 24,0z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6,2)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,0,69)",
    fillOpacity: 1,
    d: " M10,14.90999984741211 C10,14.90999984741211 10,17 10,17 C10,17.549999237060547 9.550000190734863,18 9,18 C9,18 3,18 3,18 C2.450000047683716,18 2,17.549999237060547 2,17 C2,17 2,14.90999984741211 2,14.90999984741211 C2,14.640000343322754 2.109999895095825,14.390000343322754 2.2899999618530273,14.199999809265137 C2.2899999618530273,14.199999809265137 6,10.5 6,10.5 C6,10.5 9.710000038146973,14.210000038146973 9.710000038146973,14.210000038146973 C9.890000343322754,14.390000343322754 10,14.649999618530273 10,14.90999984741211 C10,14.90999984741211 10,14.90999984741211 10,14.90999984741211z M2,0 C0.8999999761581421,0 0,0.8999999761581421 0,2 C0,2 0.009999999776482582,5.179999828338623 0.009999999776482582,5.179999828338623 C0.009999999776482582,5.710000038146973 0.2199999988079071,6.210000038146973 0.5899999737739563,6.590000152587891 C0.5899999737739563,6.590000152587891 4,10 4,10 C4,10 0.5899999737739563,13.430000305175781 0.5899999737739563,13.430000305175781 C0.2199999988079071,13.800000190734863 0.009999999776482582,14.3100004196167 0.009999999776482582,14.84000015258789 C0.009999999776482582,14.84000015258789 0,18 0,18 C0,19.100000381469727 0.8999999761581421,20 2,20 C2,20 10,20 10,20 C11.100000381469727,20 12,19.100000381469727 12,18 C12,18 12,14.84000015258789 12,14.84000015258789 C12,14.3100004196167 11.789999961853027,13.800000190734863 11.420000076293945,13.430000305175781 C11.420000076293945,13.430000305175781 8,10 8,10 C8,10 11.40999984741211,6.599999904632568 11.40999984741211,6.599999904632568 C11.789999961853027,6.21999979019165 12,5.710000038146973 12,5.179999828338623 C12,5.179999828338623 12,2 12,2 C12,0.8999999761581421 11.100000381469727,0 10,0 C10,0 2,0 2,0 C2,0 2,0 2,0z"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoading);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loading.fa7eb1c553feeda82f791361f8df13e4.svg";